/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 3.34 PM
 */

import { api } from 'utils/index';

const defaultState = {
    items: [],
    item: {},
    transactions: {},
    meta: {
        total: 0,
        per_page: 0,
        current_page: 0,
    },
};

export default {
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }
            return ({ ...state, items: payload.data, meta: payload.meta });
        },
        fetchTransactionResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }
            return ({ ...state, transactions: payload, errors: null });
        },
        findResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }
            return ({ ...state, item: payload });
        },
        updateResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }

            return ({ ...state, item: payload, errors: null });
        },
    },
    effects: ({
        async fetch(params) {
            await api.get('users', { params })
                .then(response => this.fetchResponse(response));
        },
        async find(params) {
            await api.get(`users/${params}`)
                .then(response => this.findResponse(response));
        },
        async update(data) {
            await api.patch(`users/${data.id}`, data)
                .then(response => this.updateResponse(response));
        },

        async fetchTransaction({ userId, ...params }) {
            await api.get(`users/${userId}/transactions`, { params })
                .then(response => this.fetchTransactionResponse(response));
        },
    }),
};
